export default "__VITE_ASSET__fsOO1UT6__"